import type React from 'react'
import type { JSX } from 'react'
import type { IInlineArrowDownWithTitleProps } from 'atoms/Button/Templates'
import type { ITextBlockDescriptionForSpecialRowProps } from 'blocks/TextBlock/Templates'
import type { IContainerDescriptionProps } from '../ContainerDescription'

import { InlineArrowDownWithTitle } from 'atoms/Button/Templates'
import { TextBlockDescriptionForSpecialRow } from 'blocks/TextBlock/Templates'
import { ContainerDescription } from '../ContainerDescription'
import { ContainerDescriptionRowGap } from '../ContainerDescription.h'

export interface IContainerDescriptionForSpecialRowWithAngleProps extends Omit<
  IContainerDescriptionProps,
  'children'
> {
  children?: React.ReactNode
  title?: ITextBlockDescriptionForSpecialRowProps['title']
  description?: ITextBlockDescriptionForSpecialRowProps['description']
  buttonTitle?: IInlineArrowDownWithTitleProps['title']
  onSeeAllClick?: () => void
}

export const ContainerDescriptionForSpecialRowWithAngleButton = ({
  title = '',
  description = '',
  buttonTitle = '',
  rowGap = ContainerDescriptionRowGap.INDENT_40,
  children,
  onSeeAllClick,
  ...rest
}: IContainerDescriptionForSpecialRowWithAngleProps): JSX.Element => (
  <ContainerDescription rowGap={rowGap} {...rest}>
    <TextBlockDescriptionForSpecialRow
      title={title}
      description={description}
      width={100}
    />
    {children ? (
      children
    ) : buttonTitle ? (
      <InlineArrowDownWithTitle onClick={onSeeAllClick} title={buttonTitle} />
    ) : null}
  </ContainerDescription>
)

ContainerDescriptionForSpecialRowWithAngleButton.displayName =
  'ContainerDescriptionForSpecialRowWithAngleButton'
